import { IbcShipTypeEnum } from 'src/enums/stowage/ibcShipTypeEnum';
import { ImoShipTypeEnum } from 'src/enums/stowage/imoShipTypeEnum';
import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const incompatibleIbcShipTypeHardRule: StowageRuleBM = {
    id: StowageRuleId.IncompatibleIbcShipTypeHardRule,
    name: 'A cargo cannot be stowed in a tank with an incompatible IBC ship type.',
    lastUpdatedUtc: '2024-07-26T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Cargo property product.category.isAnnexIIChapter17',
                            fieldPath: 'cargo.product.category.isAnnexIIChapter17',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                operator: BooleanOperator.OR,
                children: [
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.imoTankType',
                                            fieldPath: 'tank.imoTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: ImoShipTypeEnum.Two.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.shipType',
                                            fieldPath: 'cargo.product.category.shipType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcShipTypeEnum.One.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.imoTankType',
                                            fieldPath: 'tank.imoTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: ImoShipTypeEnum.Three.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.shipType',
                                            fieldPath: 'cargo.product.category.shipType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcShipTypeEnum.One.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.imoTankType',
                                            fieldPath: 'tank.imoTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: ImoShipTypeEnum.Three.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.shipType',
                                            fieldPath: 'cargo.product.category.shipType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcShipTypeEnum.Two.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                        ],
                    },
                    {
                        operator: BooleanOperator.AND,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank property tank.imoTankType',
                                            fieldPath: 'tank.imoTankType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: ImoShipTypeEnum.Three.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Cargo property product.category.shipType',
                                            fieldPath: 'cargo.product.category.shipType',
                                            type: 'number',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'number',
                                            referenceValue: IbcShipTypeEnum.TwoK.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Incompatible IBC ship type',
    },
};
